import React from "react";

import { Button, message, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoles,
  tripApproval,
  updateTripApproval,
  UpdateTripApproval,
} from "../../../actions/companySettings";
import { hasAccess, objectToFormData } from "../../../utils";
import PageHeader from "../../PageHeader";
import "./../styles/setting.css";
import HirarchicalApproval from "./HirarchicalApproval";

const { TabPane } = Tabs;

message.config({
  maxCount: 3,
});

const ApprovalTrip = () => {
  const dispatch = useDispatch();
  const [tripApprovalData, setTripApprovalData] = React.useState([]);
  const [rolesData, setRolesData] = React.useState([]);
  const tripApprovalResponse = useSelector(
    (state) => state.companySetting.tripApproval || {},
  );
  const updateTripApprovalResponse = useSelector(
    (state) => state.companySetting.updateTripApproval || {},
  );
  const rolesResponse = useSelector(
    (state) => state.companySetting.getRoles || {},
  );
  const [editMode, setEditMode] = React.useState(false);
  const [selectedRoles, setSelectedRoles] = React.useState([]);

  const setTab = () => {};

  React.useEffect(() => {
    dispatch(tripApproval({}));
    dispatch(getRoles({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: { response: { trip_approvals = [] } = {}, status = false } = {},
    } = tripApprovalResponse;
    if (status && trip_approvals) {
      setTripApprovalData(
        trip_approvals?.map((ele, idx) => ({ ...ele, level: idx })),
      );
      setSelectedRoles(trip_approvals.map((k) => k.role_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripApprovalResponse]);

  React.useEffect(() => {
    const {
      data: {
        response: { trip_approvals = [] } = {},
        status = "",
        message: res_message = "",
        errors = "",
      } = {},
    } = updateTripApprovalResponse;
    if (status && trip_approvals) {
      setTripApprovalData(
        trip_approvals?.map((ele, idx) => ({ ...ele, level: idx })),
      );
      setSelectedRoles(trip_approvals.map((k) => k.role_id));
      setEditMode(false);
      dispatch({
        type: UpdateTripApproval.RESET,
      });
    } else if (status === false) {
      dispatch({
        type: UpdateTripApproval.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTripApprovalResponse]);

  React.useEffect(() => {
    const { data: { response: { roles = {} } = {}, status = false } = {} } =
      rolesResponse;
    if (status) {
      setRolesData(roles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesResponse]);

  const handleSubmit = () => {
    const dataArray = tripApprovalData.map(
      ({ role_name, id, ...rest }) => rest,
    );
    dispatch(
      updateTripApproval(objectToFormData({ trip_approvals: [...dataArray] })),
    );
  };

  const handleCancel = () => {
    setEditMode(false);
    const filterArray = tripApprovalData[tripApprovalData.length - 1];
    if (!filterArray?.role_id) {
      tripApprovalData.splice(tripApprovalData.length - 1);
      setTripApprovalData([...tripApprovalData]);
    }
  };

  const handleApproveList = (type, key) => {
    if (type === "add") {
      setTripApprovalData([
        ...tripApprovalData,
        {
          can_approve_or_reject: false,
          // can_reimburse: false,
          id: tripApprovalData.length,
          level: tripApprovalData.length,
          role_id: "",
        },
      ]);
    } else {
      const filterArray = tripApprovalData.filter((obj) => obj.level !== key);
      const updatedArray = filterArray.map(({ level, ...rest }, index) => {
        return { level: index, ...rest };
      });
      setTripApprovalData([...updatedArray]);
    }
  };

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Trip Approval`}
          navigation={{
            Home: "/dashboard/",
            "Trip Approval": null,
          }}
        />
      </div>
      <Tabs onChange={setTab} type="card" size="large" className="custom-tabs">
        <TabPane tab="Hierarchical Approvals" key="preferences">
          <div className="tabContentWrapper">
            <HirarchicalApproval
              approvalData={tripApprovalData}
              setApprovalData={setTripApprovalData}
              editMode={editMode}
              handleList={handleApproveList}
              selectedRoles={selectedRoles}
              setSelectedRoles={setSelectedRoles}
              rolesData={rolesData}
            />
            {editMode && (
              <Button
                type="default"
                ghost
                className="approve-add-btn mt1"
                onClick={() => handleApproveList("add")}
              >
                + Add one more
              </Button>
            )}
            <div className="floatBottom">
              {!editMode && hasAccess("approvals", "write") && (
                <Button
                  className="formButton mt1 primaryButton"
                  onClick={() => setEditMode(true)}
                >
                  Edit
                </Button>
              )}
              {editMode && (
                <>
                  <Button
                    key="1"
                    className="formButton mt1 primaryButton"
                    onClick={() => handleSubmit()}
                  >
                    Save
                  </Button>
                  <Button
                    key="2"
                    className="cancelButton ml1 mt1"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default ApprovalTrip;
